/**
 * Where the screens of a sitting lead. D-172: the site's demo and its own paths are gone, only the
 * learner space remains.
 */

import { createContext, useContext } from "react";

export interface AcademyPaths {
  home: string;
  attempt: (id: string) => string;
  results: (id: string) => string;
}

export const LEARNER_PATHS: AcademyPaths = {
  home: "/academy/home",
  attempt: (id) => `/academy/attempt/${id}`,
  results: (id) => `/academy/attempt/${id}/results`,
};

export const AcademyPathsContext = createContext<AcademyPaths>(LEARNER_PATHS);

export function useAcademyPaths(): AcademyPaths {
  return useContext(AcademyPathsContext);
}

/** The sections of a finished sitting whose writing or speaking waits for its AI correction: the
 * day's budget of the free mocks was reached (D-172). Read from the raw results of the sitting. */
export function unavailableSkills(raw: unknown): Set<string> {
  const out = new Set<string>();
  const results = raw && typeof raw === "object" && "results" in raw ? (raw as { results: unknown }).results : raw;
  if (!results || typeof results !== "object") return out;
  for (const [skill, row] of Object.entries(results as Record<string, unknown>)) {
    if (row && typeof row === "object" && (row as { unavailable?: unknown }).unavailable === true) out.add(skill);
  }
  return out;
}
